import React, { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import allImages from "../../assets/images-import";
import { forgotPassword } from "../../services/authService";

export const PasswordResetContent = () => {
  const [email, setEmail] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (!email.trim()) {
      setError("Email is required.");
      return;
    }

    if (!/\S+@\S+\.\S+/.test(email.trim())) {
      setError("Please enter a valid email address.");
      return;
    }

    try {
      setIsSubmitting(true);
      const response = await forgotPassword(email);

      if (response?.isSuccess) {
        setIsSubmitted(true);
        toast.success(
          response.message || "Password reset link sent to your email."
        );
      } else {
        setError(response?.message || "Unable to send reset link.");
      }
    } catch (err) {
      const apiMessage =
        err.response?.data?.message ||
        err.message ||
        "Unable to send reset link. Please try again.";
      setError(apiMessage);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="auth-page-wrapper auth-bg-cover py-5 d-flex justify-content-center align-items-center min-vh-100">
      <div className="auth-page-content overflow-hidden pt-lg-5">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div
                className="card overflow-hidden"
                style={{ boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px" }}
              >
                <div className="row g-0 aligning-item">
                  <div className="col-lg-6">
                    <div
                      className="p-lg-5 p-4 auth-one-bg"
                      style={{
                        backgroundImage: `url(${allImages.SigninPageBack})`,
                        backgroundPosition: "center",
                        opacity: 0.9,
                        height: "540px",
                        backgroundRepeat: "no-repeat",
                        backgroundSize: "100%",
                      }}
                    ></div>
                  </div>

                  <div className="col-lg-6">
                    <div className="card-body p-md-5 mx-md-4">
                      <div className="text-center mt-2 mb-2">
                        <Link
                          to="/auth/signin"
                          className="d-inline-block auth-logo"
                          style={{ marginBottom: "30px" }}
                        >
                          <img
                            src={allImages.logoDark}
                            alt="Logo"
                            height="60"
                          />
                        </Link>
                      </div>

                      <div className="text-center">
                        <h4
                          className="fw-bolder"
                          style={{
                            color: "#000",
                            fontSize: "16px",
                            marginBottom: "4px",
                          }}
                        >
                          Forgot Password?
                        </h4>
                        <p className="text-muted mb-0">
                          Enter your email and we&apos;ll send reset instructions
                        </p>
                      </div>

                      {isSubmitted ? (
                        <div className="mt-4">
                          <div
                            className="alert alert-success text-center"
                            role="alert"
                          >
                            Check your email for password reset instructions.
                          </div>
                          <div className="text-center mt-4">
                            <Link
                              to="/auth/signin"
                              className="btn btn-secondary btn-primary-login w-100"
                            >
                              Back to login
                            </Link>
                          </div>
                        </div>
                      ) : (
                        <form onSubmit={handleSubmit} className="mt-4">
                          <div
                            className="alert alert-warning text-center mb-4"
                            role="alert"
                          >
                            Instructions will be sent to your registered email
                            address.
                          </div>

                          {error && (
                            <div className="alert alert-danger" role="alert">
                              {error}
                            </div>
                          )}

                          <div className="mb-4">
                            <label htmlFor="email" className="form-label">
                              Email
                            </label>
                            <input
                              type="email"
                              className="form-control"
                              id="email"
                              style={{ minHeight: "50px" }}
                              placeholder="Enter email"
                              value={email}
                              onChange={(e) => setEmail(e.target.value)}
                              required
                            />
                          </div>

                          <div className="text-center pt-1 pb-1">
                            <button
                              type="submit"
                              className="btn btn-secondary btn-primary-login w-100"
                              disabled={isSubmitting}
                            >
                              {isSubmitting ? "Sending..." : "Send Reset Link"}
                            </button>
                          </div>
                        </form>
                      )}

                      {!isSubmitted && (
                        <div className="text-center mt-4">
                          <p className="mb-0 text-muted">
                            Remember your password?{" "}
                            <Link
                              to="/auth/signin"
                              className="fw-semibold text-decoration-underline"
                              style={{ color: "#4b38b3" }}
                            >
                              Back to login
                            </Link>
                          </p>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
